import {observer} from 'mobx-react';
import GoalSubnav from 'main/containers/performance_goals/GoalSubnav';
import {t} from 'shared/core';
import {endpoints} from 'main/tools';
import {Layout} from 'shared/components';
import GoalList from '../../GoalList';


const CompanyGoals = observer(({match, history, scope}) => {
  return (
    <div>
      <GoalSubnav scope={scope}/>
      <Layout>
        <GoalList
          {...{match, history}}
          canCreateGoals={true}
          title={t('goals.Company Goals')}
          endpoint={endpoints.PERFORMANCE_GOALS.COMPANY_GOALS}
          showEmployeeFilters
        />
      </Layout>
    </div>
  );
});

export default CompanyGoals;
